import Pricing from './Pricing/Pricing';
import Terms from './Terms/Terms';

export default function PricingAndTerms() {
  return (
    <div className="flex flex-row justify-between">
      <Pricing />
      <Terms />
    </div>
  );
}
